// ABOUTME: Shared utility functions for billing-related formatting.
// ABOUTME: Used by BillingPage, UpgradePage, and other billing components.

/**
 * Format a subscription tier identifier into a human-readable name.
 */
export function formatTierName(tier: string): string {
  const tierNames: Record<string, string> = {
    freemium: 'Free',
    base_individual: 'Base Individual',
    basic: 'Basic',
    standard: 'Standard',
    enterprise: 'Enterprise',
    enterprise_plus: 'Enterprise Plus',
  };
  return tierNames[tier] || tier;
}

/**
 * Format a date string into a month/year display.
 */
export function formatBillingDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
  });
}

/**
 * Format a date string into a full "Month Day, Year" display (e.g., "March 15, 2026").
 * Suitable for specific dates like cancellation or expiry dates.
 */
export function formatPreciseDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}
